// src/components/motion/FadeInwhenVisible.jsx

import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "../../utils/motion";

export default function SectionIntro({
  eyebrow,
  title,
  description,
  align = "left",
}) {
  return (
    <motion.div
      className={`section-intro section-intro--${align}`}
      variants={fadeUp}
      initial="hidden"
      whileInView="show"
      viewport={viewportOnce}
    >
      {eyebrow ? <div className="section-eyebrow">{eyebrow}</div> : null}
      <h2>{title}</h2>
      {description ? <p>{description}</p> : null}
    </motion.div>
  );
}
